/* sangria-blog-v3.css */
const tenant = "lulas";
const apiURL = "https://apiv3-prod-in.sangria.tech";
const cloudFrontURL = "https://d1msew97rp2nin.cloudfront.net";
const storeURL = "https://lulas-garden.myshopify.com";
const amplifyURL = "https://lulas-prodin.sangria.tech";

 window.onload = function() {
    var baseDomain = window.location.hostname;
    var referrerURL = document.referrer;
    var originalURL = window.location.href.split('?')[0]; 
    var utmParams = "?utm_medium=sangria&utm_source=sangria_blogs&utm_campaign=sangria_organic";

    function appendUTM(url, params) {
        return url + params;
    }

    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    var updatedURL;
    if (!referrerURL || referrerURL === '' || !referrerURL.includes(baseDomain)) {
        // Append UTM parameters to the URL
        updatedURL = appendUTM(originalURL, utmParams);
        window.history.replaceState(null, '', updatedURL); 
        console.log("Updated URL with UTM parameters:", updatedURL);

        // Set UTM cookies
        setCookie("utm_medium", "sangria", 30);
        setCookie("utm_source", "sangria_blogs", 30);
        setCookie("utm_campaign", "sangria_organic", 30);

        console.log("UTM cookies set: utm_medium, utm_source, utm_campaign");
    } else {
        updatedURL = originalURL;
        console.log("URL not updated (same domain as referrer):", updatedURL);
    }
};

  document.addEventListener("DOMContentLoaded", async () => {
    await loadProductCards();
    await loadShopifyCart();
  await recomendationContent();
  });

async function recomendationContent () {
  const url = new URL(window.location.href);
  const pathnameParts = url.pathname.split("/");

  // Get the category value (second-to-last part of the URL path)
  const categoryValue = pathnameParts[pathnameParts.length - 2];
  console.log(categoryValue, 'blog url');

  // Get the slug (last part of the URL path, before any query string)
  const slug = pathnameParts.pop().split("?")[0];

  // Make the API call to fetch data
  const response = await fetch(`${apiURL}/blog/${categoryValue}/${slug}`, {
    method: 'GET', // Using GET method
    headers: {
      'Accept': 'application/json',  // Accept JSON response
      'x-tenant-identifier': `${tenant}`  // Custom header for tenant identification
    }
  });
console.log(response,'response  for related readssssssssssss');
  const data = await response.json();
  console.log(data?.data?.data,'valuess');
  
  // Check if the API call was successful
  if (data.success && data?.data?.data?.length > 0) {
    const blogPosts = data?.data?.data; // Access the blog data array

    const htmlValues = `
      <style>
        #carouselContent {
          scrollbar-width: none;
        }
        #carouselContent::-webkit-scrollbar {
          display: none;
        }
        .gradient-overlay {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
        }
      </style>
      <div class="w-full mx-auto" id="carousel-container">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4" id="sg-defaultCarousel-heading">Suggested for you</h2>
        </div>

        <div class="relative">
          <button id="prevBtn" class="z-10 absolute -left-6 bottom-1/2 w-12 h-12 rounded-full bg-neutral-100 shadow-md hidden md:flex items-center justify-center transition hover:bg-gray-200">&#8592;</button>

          <div id="carouselContent" class="flex overflow-x-auto overflow-hidden scroll-smooth space-x-4"></div>

          <button id="nextBtn" class="absolute -right-6 bottom-1/2 w-12 h-12 rounded-full bg-neutral-100 shadow-md hidden md:flex items-center justify-center transition hover:bg-gray-200">&#8594;</button>
        </div>

        <div id="dotContainer" class="flex justify-center gap-2 mt-4"></div>
      </div>
    `;
    document.querySelector("#sg-shopable-defaultCarousel-container").innerHTML = htmlValues;
    initCarousel(blogPosts); // Pass the blog data directly to initialize the carousel
  } else {
    console.error("Failed to fetch data or data is missing.");
    document.querySelector("#sg-shopable-defaultCarousel-container").innerHTML = null;
  }
}

function initCarousel(blogPosts) {
  const carouselContent = document.getElementById("carouselContent");
  const dotsContainer = document.getElementById("dotContainer");

  // Clear previous content if necessary
  carouselContent.innerHTML = '';

  blogPosts.forEach((post, i) => {
    const card = document.createElement("div");
     card.className = "text-card-foreground shadow w-[288px] h-[296px] md:w-[275.33px] md:h-[286.5px] rounded-xl bg-[#F5F5F5] transition-all duration-300 transform md:scale-100 max-md:scale-90";
 // Wrap the card content inside an anchor tag with target="_blank"
    const cardLink = document.createElement('a');
    cardLink.href = `${storeURL}/blogs/${post?.category?.slug}/${post.slug}`;  // Set the URL from the post object (use a fallback if no link is provided)
    cardLink.target = "_blank";  // Open in a new tab
    cardLink.className = "block w-[288px] h-[296px] md:w-[275.33px] md:h-[286.5px]";  // Make the link block level to cover the entire card

    // Add content inside the anchor tag
    cardLink.innerHTML = `
      <div class="relative w-full aspect-[4/3]" id="sg-defaultShopableCardWidget-image-container">
        <img id="sg-shopableBlogRecoImg" src="${cloudFrontURL}/${post?.featuredImage?.image}" alt="${post?.title}" class="object-cover rounded-t-xl">
      </div>
      <div class="p-4 bg-neutral-100" id="sg-defaultCardWidget-content-container">
      <h3 id="sg-defaultShopableCardWidget-content" class="text-base md:text-lg font-semibold leading-tight text-gray-900 line-clamp-2 mt-0 mb-0">${post?.title}</h3>
       </div>
   `;

    // Append the anchor tag inside the card
    card.appendChild(cardLink);
    carouselContent.appendChild(card);

    const dot = document.createElement("button");
    dot.className = `w-2 h-2 rounded-full bg-black/30 transition-all dot-btn`;
    dot.dataset.index = i;
    dotsContainer.appendChild(dot);
  });

  // Set initial dot
  if (dotsContainer.children[0]) {
    dotsContainer.children[0].classList.remove("bg-black/30", "w-2");
    dotsContainer.children[0].classList.add("bg-black", "w-4");
  }

  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");

  const dotButtons = () => document.querySelectorAll(".dot-btn");
  const getCardWidth = () => carouselContent.querySelector("div")?.offsetWidth + 16;

  let currentIndex = 0;
  const totalCards = blogPosts.length;

  function updateDots() {
    dotButtons().forEach((dot, idx) => {
      dot.classList.remove("w-4", "bg-black");
      dot.classList.add("w-2", "bg-black/30");
      if (idx === currentIndex) {
        dot.classList.remove("bg-black/30", "w-2");
        dot.classList.add("w-4", "bg-black");
      }
    });
  }

  prevBtn.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      carouselContent.scrollTo({ left: currentIndex * getCardWidth(), behavior: "smooth" });
      updateDots();
    }
  });

  nextBtn.addEventListener("click", () => {
    if (currentIndex < totalCards - 1) {
      currentIndex++;
      carouselContent.scrollTo({ left: currentIndex * getCardWidth(), behavior: "smooth" });
      updateDots();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("dot-btn")) {
      currentIndex = parseInt(e.target.dataset.index);
      carouselContent.scrollTo({ left: currentIndex * getCardWidth(), behavior: "smooth" });
      updateDots();
    }
  });

  window.addEventListener("resize", () => {
    carouselContent.scrollTo({ left: currentIndex * getCardWidth(), behavior: "smooth" });
  });
}

  
async function loadProductCards(retry = false) {
  try {
    const slug = window.location.pathname.split("/").pop();
    const response = await fetch(`${amplifyURL}/blogs/shopify/${slug}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const productCardHtml = await response.text();
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = productCardHtml;

    const isPlaceholder = tempContainer.innerHTML.includes('<template id="B:');
    console.log(isPlaceholder, "isPlaceholder");

    if (isPlaceholder) {
      if (!retry) {
        console.warn("Placeholder detected. Retrying once after 500ms...");
        setTimeout(() => loadProductCards(true), 500);
        return;
      } else {
        throw new Error("Still receiving placeholder content after retry.");
      }
    }

    let success = false;

    for (let i = 1; i <= 10; i++) {
      const card = tempContainer.querySelector(
        `#sg-shoppable-product-card-${i}`
      );
      const placeholder = document.getElementById(`sgEngagement${i}`);

      if (card && placeholder && !card.querySelector("template")) {
        placeholder.innerHTML = "";
        const cardClone = card.cloneNode(true);
        placeholder.appendChild(cardClone);
        await initializeVariantHandling(cardClone);
        success = true;
      } else if (!card) {
        break;
      }
    }

    if (!success && !retry) {
      console.warn("No valid cards rendered. Retrying after 500ms...");
      setTimeout(() => loadProductCards(true), 500);
      return;
    }

    await loadDynamicScripts(tempContainer);
    attachEventListeners();
  } catch (error) {
    console.error("Error loading product cards:", error);
  }
}

async function initializeVariantHandling(card) {
  const variantContainer = card.querySelector("#sg-shoppable-variant-selector");
  const hiddenInputJson = card.querySelector("#sg-shop-variant-id-values");
  const hiddenInput = card.querySelector("#variant-id-input");
  const salePrice = card.querySelector("#sg-shoppable-regular-price");

  if (variantContainer && hiddenInputJson && hiddenInput && salePrice) {
    const selects = variantContainer.querySelectorAll("select");
    const variants = JSON.parse(hiddenInputJson.value.replace(/&quot;/g, '"'));

    function updateVariantDetails() {
      const selectedValues = Array.from(selects).map((select) => select.value);
      const matchedVariant = variants.find((variant) => {
        const attrValues = Object.values(variant.productAttributes || {});
        return selectedValues.every((val) => attrValues.includes(val));
      });

      const addToCartButton = card.querySelector(
        "#sg-shoppable-add-to-cart-button"
      );
      const addToCartLabel = card.querySelector("#sg-add-to-cart-label");

      if (matchedVariant) {
        console.log(matchedVariant,'matchedVariant');
        hiddenInput.value = matchedVariant.productAttributeId;
        salePrice.textContent = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: matchedVariant.currencyCode || "USD",
        }).format(matchedVariant.salePrice || 0);

        const hasStock = parseInt(matchedVariant.inventoryQuantity) > 0;

        if (hasStock) {
          addToCartButton.disabled = false;
          addToCartButton.classList.remove(
            "opacity-50",
            "cursor-not-allowed",
            "bg-gray-400"
          );
          addToCartButton.classList.add("bg-black", "hover:bg-gray-800");
          addToCartLabel.textContent = "Add To Cart";
        } else {
          addToCartButton.disabled = true;
          addToCartButton.classList.add(
            "opacity-50",
            "cursor-not-allowed",
            "bg-gray-400"
          );
          addToCartButton.classList.remove("bg-black", "hover:bg-gray-800");
          addToCartLabel.textContent = "Add To Cart";
        }
      } else {
        hiddenInput.value = "";
        salePrice.textContent = "";
        console.log("No matching variant found.");
      }
    }

    selects.forEach((select) => {
      select.addEventListener("change", updateVariantDetails);
    });

    updateVariantDetails(); // Trigger on load
  }
}

async function loadDynamicScripts(container) {
  container.querySelectorAll("script").forEach((script) => {
    const newScript = document.createElement("script");
    if (script.src) {
      newScript.src = script.src;
    } else {
      newScript.textContent = script.textContent;
    }
    document.body.appendChild(newScript);
  });
}




  let cartItems = [];
  let cartTotal = 0;

  async function loadShopifyCart() {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      console.log("dataaaaaaaaaa..........................",data);

      cartItems = data.items.map((item) => ({
        id: item.variant_id.toString(),
        title: item.product_title,
        price: parseFloat(formatPrice(item.original_price)),
        image: item.image,
        quantity: item.quantity,
        variantAttributes: Object.fromEntries(item.options_with_values.map(opt => [opt.name.toLowerCase(), opt.value]))
      }));

      updateCartUI();
    } catch (error) {
      console.error("Error loading Shopify cart:", error);
    }
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(2);
  }

  function customEvent(action, event_label = "", event_title = "", value = 0) {
    gtag("event", action, {
      event_label: event_label,
      event_title: event_title,
      value: value,
    });
    console.log("Custom event triggered:", action, event_label, event_title, value);
  }
   
  function handleClickEvents(action, event_title, label = "") {
    console.log("Inside handleClickEvents", )
    const from = window.location.href;
    let event_label = "";
    if (label != "") {
      event_label = label;
    } else if (from.includes("/blogs")) {
      event_label = "Blog";
    } else if (from.includes("/pages")) {
      event_label = "PLP";
    }
    customEvent(action, event_label, event_title);
  }
   

  async function addToCart(product) {
    try {
      handleClickEvents('sangria_addtocart', 'Add to cart', 'Blog');

      const payload = {
        items: [
          {
            id: product.id,
            quantity: product.quantity || 1,
          },
        ],
      };

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to add product to Shopify cart");

      const existing = cartItems.find((item) => item.id === product.id);
      if (existing) {
        existing.quantity += 1;
      } else {
        cartItems.push({
          id: product.id,
          title: product.title,
          price: parseFloat(product.price),
          image: product.image,
          quantity: product.quantity || 1,
         variantAttributes:product?.variantAttributes || {}
          
        });
      }

      updateCartUI();
      openCartDrawer();
    } catch (error) {
      console.error("Error adding to Shopify cart:", error);
    }
  }

  function updateCartUI() {
    const container = document.getElementById("sg-cart-items");
    const subtotal = document.getElementById("sg-cart-subtotal");

    if (container) {
      container.innerHTML = cartItems.length
        ? ""
        : '<p class="text-center py-8 text-gray-500">Your cart is empty</p>';
console.log(cartItems,'cartItems');
      cartItems.forEach((item) => {
        const el = document.createElement("div");
        el.className = "cart-item";
        console.log(item,'item')
         // Generate attribute lines dynamically (e.g., size, color, etc.)
    const attributeHtml = Object.entries(item?.variantAttributes || {})
      .map(
        ([key, value]) =>
          `<p class="text-sm text-gray-700 mt-1 mb-0">${key.charAt(0).toUpperCase() + key.slice(1)}: ${value}</p>`
      )
      .join("");
        el.innerHTML = `
          <img src="${item.image}" alt="${item.title}" class="cart-item-image">
          <div class="flex flex-col justify-evenly flex-grow m-4">
            <h4 class="font-medium flex-shrink-0">${item.title}</h4>
             ${attributeHtml}

        <span class="">$${item.price.toFixed(2)} </span>
            <div class="flex justify-between items-center">
              <div class="flex items-center border rounded">
                <button class="px-6 py-1 decrease-quantity cursor-pointer" data-id="${item.id}">-</button>
                <span class="px-2">${item.quantity}</span>
                <button class="px-6 py-1 increase-quantity cursor-pointer" data-id="${item.id}">+</button>
              </div>
              <button class="ml-2 remove-item cursor-pointer" data-id="${item.id}">🗑️</button>
            </div>
          </div>
        `;
        container.appendChild(el);
      });

      container.querySelectorAll(".increase-quantity").forEach((btn) =>
        btn.addEventListener("click", () => {
          const item = cartItems.find((i) => i.id === btn.dataset.id);
          if (item) item.quantity += 1;
          updateCartUI();
        })
      );

      container.querySelectorAll(".decrease-quantity").forEach((btn) =>
        btn.addEventListener("click", () => {
          const item = cartItems.find((i) => i.id === btn.dataset.id);
          if (item && item.quantity > 1) item.quantity -= 1;
          updateCartUI();
        })
      );

      container.querySelectorAll(".remove-item").forEach((btn) =>
        btn.addEventListener("click", async () => {
          const id = btn.dataset.id;

          try {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
              },
              body: JSON.stringify({
                id,
                quantity: 0,
              }),
            });

            cartItems = cartItems.filter((i) => i.id !== id);
            updateCartUI();
          } catch (error) {
            console.error("Failed to remove item from cart:", error);
          }
        })
      );
    }

    if (subtotal) {
      cartTotal = cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
      subtotal.textContent = `$${cartTotal.toFixed(2)} USD`;
    }
  }

  function attachEventListeners() {
    document.querySelectorAll("#sg-shoppable-add-to-cart-button").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const card = btn.closest("#sg-shoppable-product-card");
         const sizeSelect = card.querySelector("#sg-shoppable-size-selector")?.value;
       const colorSelect = card.querySelector("#sg-shoppable-color-selector")?.value;
       const title = card.querySelector("#sg-shoppable-product-title")?.textContent?.trim();
        const price = card.querySelector("#sg-shoppable-regular-price")?.textContent?.trim()?.replace(/[^\d.]/g, "");
        const image = card.querySelector("#sg-shoppable-product-image")?.src;
        const id = card.querySelector('input[name="id"]')?.value;

       const variantAttributes = {};
const variantSelector = card.querySelector("#sg-shoppable-variant-selector");

if (variantSelector) {
  const selects = variantSelector.querySelectorAll("select");
  selects.forEach((select) => {
    const attrKey =
      select.getAttribute("data-attr-key") || // ✅ This now returns the correct key like "size"
      select.getAttribute("name") ||
      select.getAttribute("id")?.replace("sg-shoppable-", "") ||
      `attribute-${Math.random()}`;

    variantAttributes[attrKey] = select.value;
  });
}

console.log("Final variantAttributes:", variantAttributes);


      // ✅ Show selected variant values (also covers defaults on first click)
      console.log("Selected Variant Attributes:", variantAttributes);
        
        if (id && title && price && image) {
           console.log("Variant Attributes:", variantAttributes);
          console.log("test 7")
          addToCart({ id, title, price, image, quantity: 1, variantAttributes });
        }
      });
    });

 

    document.querySelectorAll("#sg-zoom-toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        const wrapper = btn.closest("#sg-shoppable-image-wrapper");
        if (!wrapper) return;
        wrapper.classList.toggle("zoomed");

        const productCard = btn.closest('[id^="sg-shoppable-product-card-"]');
        if (productCard) {
          productCard.classList.toggle("zoomed")
        }

        const icon = btn.querySelector("svg");
        const zoomIn = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-zoom-in w-5 h-5 text-gray-600"><circle cx="11" cy="11" r="8"></circle><line x1="21" x2="16.65" y1="21" y2="16.65"></line><line x1="11" x2="11" y1="8" y2="14"></line><line x1="8" x2="14" y1="11" y2="11"></line></svg>`;
        const zoomOut = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-zoom-in w-5 h-5 text-gray-600"><circle cx="11" cy="11" r="8"></circle><line x1="21" x2="16.65" y1="21" y2="16.65"></line><line x1="8" x2="14" y1="11" y2="11"></line></svg>`;
        icon.outerHTML = wrapper.classList.contains("zoomed") ? zoomOut : zoomIn;
      });
    });

    const closeBtn = document.getElementById("sg-close-cart");
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);

    const overlay = document.getElementById("sg-cart-overlay");
    if (overlay) {
      overlay.addEventListener("click", closeCartDrawer); // 🆕 Added to close cart when clicking outside
    }
  }

  function openCartDrawer() {
    document.getElementById("sg-cart-drawer")?.classList.add("open");
    document.getElementById("sg-cart-overlay")?.classList.add("open");
    document.body.classList.add("drawer-open");
  }

  function closeCartDrawer() {
    document.getElementById("sg-cart-drawer")?.classList.remove("open");
    document.getElementById("sg-cart-overlay")?.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }


document.addEventListener("click", async (event) => {
  const viewBtn = event.target.closest("#sg-view-button");
  if (!viewBtn) return;
 event.preventDefault(); // 👈 Prevent default action like link navigation
  const modal = document.getElementById("sg-quick-view-modal");
  console.log(modal,'modal');
  const content = document.getElementById("sg-quick-view-content");
  content.innerHTML = "Loading...";
 
  const card = viewBtn.closest("[id^='sg-shoppable-product-card']");
  if (!card) return;
 
  try {
    const image = card.querySelector("#sg-shoppable-product-image")?.src;
    const title = card.querySelector("#sg-shoppable-product-title")?.textContent;
    const price = card.querySelector("#sg-shoppable-regular-price")?.textContent;
    const salePrice=card.querySelector("#sg-shoppable-sale-price")?.textContent;
    const variantId = card.querySelector("#variant-id-input")?.value;
    const desc = card.querySelector("#sg-hidden-description")?.value;
    const productUrl = card.querySelector("#sg-shoppable-product-url")?.href;
   const variantWrapper = card.querySelector("#sg-shoppable-variant-selector");
    const variantSelects = variantWrapper?.querySelectorAll("select") || [];
    const variants = JSON.parse(card.querySelector("#sg-shop-variant-id-values")?.value.replace(/&quot;/g, '"') || "[]");
 
    // Store cloned selectors and selected values
    const clonedSelectors = [];
    const selectedAttributes = {};
 
    variantSelects.forEach((select, idx) => {
      const name = select.getAttribute("id") || `attr-${idx}`;
      const cloned = select.cloneNode(true);
      cloned.setAttribute("data-attr-name", name);
      selectedAttributes[name] = cloned.value;
      clonedSelectors.push(cloned);
    });
    
      const numericSalePrice = parseFloat((salePrice || "").replace(/[^\d.]/g, ""));
    const showSalePrice = !isNaN(numericSalePrice) && numericSalePrice > 0;
 
    content.innerHTML = `
<!-- Left Column -->
<div class="w-full md:w-1/2 flex justify-center items-center" id="sg-quickImageWrapper" >
<img src="${image}" alt="${title}" class="rounded-xl w-full object-cover max-h-[450px]" />
</div>
 
      <!-- Right Column -->
<div class="w-full md:w-1/2 flex flex-col gap-4" id="sg-quickcontentWrapper">
<a id="sg-shoppable-product-url" target="_blank" rel="noopener noreferrer" class="block" href=${productUrl}>
<h2 class="text-2xl font-bold m-[0px]">${title}</h2>
</a>
<div class="flex gap-2 item-center">
<p id="quick-price" class="text-lg font-semibold">${price}</p>
     ${showSalePrice ? `<p id="sg-shoppable-quick-price" class="ml-2 text-lg line-through">${salePrice}</p>` : ""}   
   
</div>
          ${desc ? `<div class="text-xl text-gray-600 h-[200px] overflow-y-auto"">${desc}</div>` : ""}
<label class="block font-medium">Choose options:</label>
<div id="sg-quick-variant-wrapper" class="space-y-3"></div>
 
        <div class="flex items-center gap-4 mt-2">
<label class="font-medium">Qty:</label>
<div class="flex border rounded w-[100px] overflow-hidden">
<button class="flex-1 py-1 text-lg font-bold cursor-pointer" id="quick-qty-decrease">−</button>
<input id="quick-qty" type="number" min="1" value="1" class="w-10 text-center border-l border-r" />
<button class="flex-1 py-1 text-lg font-bold cursor-pointer" id="quick-qty-increase">+</button>
</div>
</div>
 
        <input type="hidden" name="id" value="${variantId}" id="quick-variant-id-input">
<button id="sg-quick-add-to-cart" class="mt-4 bg-black text-white py-2 px-4 rounded hover:bg-gray-800 flex justify-center gap-2 items-center" style="align-items: center; cursor:pointer;">
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag-icon lucide-shopping-bag">
<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>
<path d="M3 6h18"/>
<path d="M16 10a4 4 0 0 1-8 0"/>
</svg>
          Add To Cart
</button>
</div>
    `;
 
    // Append all selectors
    const wrapper = document.getElementById("sg-quick-variant-wrapper");
    clonedSelectors.forEach((cloned) => {
      wrapper.appendChild(cloned);
    });
 
    // Update logic for variant match
    function updateQuickVariant() {
      clonedSelectors.forEach((sel) => {
        const attr = sel.getAttribute("data-attr-name");
        selectedAttributes[attr] = sel.value;
      });
 
      const matched = variants.find((variant) => {
        const attrValues = Object.values(variant.productAttributes || {});
        return Object.values(selectedAttributes).every((val) => attrValues.includes(val));
      });
console.log(matched,'matched56');
    const hasStock = parseInt(matched.inventoryQuantity) > 0;
  if (matched) {
          console.log(matched,'matched');
          const hasStock = parseInt(matched.inventoryQuantity || "0") > 0;
          document.getElementById("quick-variant-id-input").value = matched.productAttributeId;

          const sale  = parseFloat(matched.price || 0);
          const regular= parseFloat(matched.salePrice || 0);
          const currency = matched.currencyCode || "INR";

          const quickPrice = document.getElementById("quick-price");
          const salePriceEl = document.getElementById("sg-shoppable-quick-price");

          quickPrice.textContent = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency,
          }).format(regular);

          if (showSalePrice) {
            salePriceEl.textContent = new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency,
            }).format(sale);
            salePriceEl.classList.remove("hidden");
          }

          const addToCartButton = document.getElementById("sg-quick-add-to-cart");
          if (hasStock) {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove("opacity-50", "cursor-not-allowed", "bg-gray-400");
            addToCartButton.classList.add("bg-black", "hover:bg-gray-800");
          } else {
            addToCartButton.disabled = true;
            addToCartButton.classList.add("opacity-50", "cursor-not-allowed", "bg-gray-400");
            addToCartButton.classList.remove("bg-black", "hover:bg-gray-800");
          }
        }
    }
 
    // Bind event listeners
    clonedSelectors.forEach((sel) => {
      sel.addEventListener("change", updateQuickVariant);
    });
 
    updateQuickVariant(); // Trigger on load
 
    // Quantity logic
    const qtyInput = document.getElementById("quick-qty");
    document.getElementById("quick-qty-increase").addEventListener("click", () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
    document.getElementById("quick-qty-decrease").addEventListener("click", () => {
      if (parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
    });
 
    // Add to cart
    document.getElementById("sg-quick-add-to-cart").addEventListener("click", () => {
      const id = document.getElementById("quick-variant-id-input").value;
      const qty = parseInt(qtyInput.value);
 
      if (!id || qty < 1) return;
        // Extract variant attributes from selects inside #sg-quick-variant-wrapper
  const variantAttributes = {};
  const variantWrapper = document.getElementById("sg-quick-variant-wrapper");
 
  if (variantWrapper) {
    const selects = variantWrapper.querySelectorAll("select");
    selects.forEach((select) => {
      const attrKey =
        select.getAttribute("data-attr-key") ||
        select.getAttribute("name") ||
        select.getAttribute("id")?.replace("sg-shoppable-", "") ||
        `attribute-${Math.random()}`;
 
      variantAttributes[attrKey] = select.value;
    });
  }
      console.log(variantAttributes,'variantAttributes');
 
      addToCart({
        id,
        title,
        price: document.getElementById("quick-price").textContent.replace(/[^\d.]/g, ""),
        image,
        quantity: qty,
        variantAttributes
      });
    });
 
    modal.classList.remove("hidden");
  } catch (err) {
    console.error("Quick View error:", err);
    content.innerHTML = "<p>Error loading Quick View.</p>";
  }
});

document.getElementById("sg-quick-view-modal").addEventListener("click", (event) => {
  const modal = document.getElementById("sg-quick-view-modal");
  const content = document.getElementById("sg-quick-view-content");
  const closeBtn = document.getElementById("sg-quick-view-close");

  // Check if the click was on the modal backdrop (outside of the content)
  if (event.target === event.currentTarget || event.target === closeBtn) {
    modal.classList.add("hidden");
    content.innerHTML = "";
  }
});

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.addToCart = addToCart;

